import React from 'react'
import { connect } from 'react-redux'
import Ink from 'react-ink';
import { startPayment } from '../functions/PaymentFunctions'
import { setInputQuantity, setInputQuantityDecimal } from '../actions/receiptActions.js'
import { setGroup } from '../actions/layoutActions'
import { processDiscountMenu, processSelectPager } from '../actions/keyFunctionActions'
import PropTypes from 'prop-types'

class KeyboardButton extends React.Component {
  constructor(props) {
    super(props)
    this.handleTouchTap = this.handleTouchTap.bind(this);
    this.inputHelper = this.inputHelper.bind(this);
  }

  handleTouchTap(e) {
    const {
      keylayoutgroupid,
      setGroup,
      processDiscountMenu,
      usePager,
      processSelectPager,
      pagerNumber
    } = this.props;

    if (e.currentTarget) {
      e.currentTarget.blur();
    }

    let input = this.props.inputquantity
    switch (this.props.text) {
      case 'back':
        if (input.length > 1) {
          input = input.slice(0, -1);
        } else {
          input = '0'
        }
        break;
      case '€':
        e.preventDefault();
        if (usePager && (!pagerNumber || pagerNumber === 0)) {
          processSelectPager();
        }
        if (keylayoutgroupid > 0) {
          processDiscountMenu();
          setGroup(keylayoutgroupid);
        }
        else {
          this.props.startPayment();
        }
        return;
      //input = '0';
      case '.':
        this.props.setInputQuantityDecimal(!this.props.inputquantitydecimal)
        break;
      case 'x':
        if (!input.includes('x') && input.charAt(0) !== '0')
          input = input.concat('x');
        else
          input = input.concat('');
        break;
      default:
        if (this.props.inputquantitydecimal) {
          input = input.concat('.');
          this.props.setInputQuantityDecimal(false)
        }
        input = input.concat(this.props.text)
    }

    while (input.length > 1 && input.charAt(0) === '0') {
      input = input.substr(1)
    }
    if (input.length > 0 && input.charAt(input.length - 1) === '.') {
      input = input.substr(0, input.length - 1)
    }
    if (input.length > 0 && input.charAt(0) === '.') {
      input = '0'.concat(input)
    }
    if (input.length === 0) {
      input = '0'
    }


    if (input.indexOf('.') > -1 && !input.includes('x')) {
      this.inputHelper(input, input.indexOf('.') + 4, false);
    } else if (input.includes('x')) {
      this.inputHelper(input, 14, true);
    } else {
      this.inputHelper(input, 7, false);
    }
  }

  inputHelper(input, maxLength, multiply) {

    if (multiply) {
      var dotPos = input.lastIndexOf('.');
      if (dotPos > input.indexOf('x'))
        maxLength = dotPos + 3;
    }

    if (input.length <= maxLength)
      this.props.setInputQuantity(input)
  }

  render() {
    return (
      <button onClick={this.handleTouchTap}>
        <i className={this.props.icon} />
        {this.props.icon ? '' : this.props.text}
        <Ink />
      </button>);
  }
}

KeyboardButton.propTypes = {
  text: PropTypes.string,
  icon: PropTypes.string,
  inputquantity: PropTypes.string,
  inputquantitydecimal: PropTypes.bool,
  setInputQuantity: PropTypes.func.isRequired,
  setInputQuantityDecimal: PropTypes.func.isRequired,
  startPayment: PropTypes.func.isRequired,
  processDiscountMenu: PropTypes.func.isRequired,
  processSelectPager: PropTypes.func.isRequired
}

function mapStateToProps(state) {
  return {
    inputquantity: state.receiptState.input.inputquantity,
    inputquantitydecimal: state.receiptState.input.inputquantitydecimal,
    keylayoutgroupid: state.layoutState.paymentkeygroupid,
    usePager: state.generalState.usePager,
    pagerNumber: state.receiptState.receipt.pagerNumber
  }
}

export default connect(mapStateToProps,
  {
    setInputQuantity,
    setInputQuantityDecimal,
    startPayment,
    setGroup,
    processDiscountMenu,
    processSelectPager
  })(KeyboardButton)



// WEBPACK FOOTER //
// src/components/KeyboardButton.jsx